import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WeeklyMenu, { SeasonalMenu } from './pages/WeeklyMenu';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Speisekarte from './pages/Speisekarte';
import { Toaster } from './components/ui/sonner';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); return; }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  return (
    <div className="min-h-screen flex flex-col bg-[#faf6f0]">
      <Navbar/>
      <ScrollToTop/>
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/ueber-uns" element={<About/>}/>
          <Route path="/services" element={<Services/>}/>
          <Route path="/wochenmenue" element={<WeeklyMenu/>}/>
          <Route path="/speisekarte" element={<Speisekarte/>}/>
          <Route path="/saisonkarte" element={<SeasonalMenu/>}/>
          <Route path="/galerie" element={<Gallery/>}/>
          <Route path="/kontakt" element={<Contact/>}/>
          <Route path="/admin" element={<Admin/>}/>
        </Routes>
      </main>
      <Footer/>
      <Toaster position="top-center" richColors/>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell/>
    </BrowserRouter>
  );
}

export default App;
